const ArticleTypes = {
  '0f0ea25c180346d98d35acb160bead9e': 'Article',
  '08a1ecc05b494f33a3161c0b3045d42a': 'Podcast',
  d8b293afef8847aa945b7a058bdaf096: 'Video',
};

export default ArticleTypes;
